import { consulta } from "../../global/js/funciones";

/* -------------------------------------------------------------------------- */
/*  Llamadas al API del módulo "Proyecto de vida".                            */
/*  Un solo recurso /proyecto con GET (obtener), POST (crear) y PUT (actualizar). */
/* -------------------------------------------------------------------------- */

// GET: proyecto de vida del estudiante en sesión
export const obtenerProyecto = () =>
  new Promise((resolve) => {
    consulta(`api/v1.0/proyecto_vida/proyecto`, null, "GET", (error, estado, resp) => {
      resolve({ error, estado, resp });
    });
  });

// POST: crea el proyecto (primera vez) y marca completado = 1
export const guardarProyecto = (data) =>
  new Promise((resolve) => {
    consulta(`api/v1.0/proyecto_vida/proyecto`, data, "POST", (error, estado, resp) => {
      resolve({ error, estado, resp });
    });
  });

// PUT: actualiza el proyecto (guarda la versión anterior en el historial)
export const actualizarProyecto = (data) =>
  new Promise((resolve) => {
    consulta(`api/v1.0/proyecto_vida/proyecto`, data, "PUT", (error, estado, resp) => {
      resolve({ error, estado, resp });
    });
  });

// GET: versiones del proyecto (actual + historial) con su contenido
export const obtenerVersiones = () =>
  new Promise((resolve) => {
    consulta(`api/v1.0/proyecto_vida/versiones`, null, "GET", (error, estado, resp) => {
      resolve({ error, estado, resp });
    });
  });

/* -------------------------------------------------------------------------- */
/*  Gestión (Consulta y seguimiento) — pendientes de cablear a la vista.       */
/* -------------------------------------------------------------------------- */

// POST: autocomplete de estudiantes por documento, nombre o usuario (debounce).
export const buscarEstudiantesGestion = (dato) =>
  new Promise((resolve) => {
    consulta(`api/v1.0/personas/buscar`, { dato, tipo: "1" }, "post", (error, estado, resp) => {
      resolve({ error, estado, resp });
    });
  });

// GET: listado de estudiantes con proyecto completado (semestre desde SICUC).
// Filtros: por programa (+ semestre opcional) o por un estudiante específico.
export const listarEstudiantesGestion = ({ programa, semestre, estudiante } = {}) => {
  let params = [];
  if (programa) params.push(`programa=${programa}`);
  if (semestre) params.push(`semestre=${semestre}`);
  if (estudiante) params.push(`estudiante=${estudiante}`);
  const qs = params.length ? `?${params.join("&")}` : "";
  return new Promise((resolve) => {
    consulta(`api/v1.0/proyecto_vida/gestion/estudiantes${qs}`, null, "GET", (error, estado, resp) => {
      resolve({ error, estado, resp });
    });
  });
};

// GET: proyecto de vida vigente de un estudiante específico (detalle en gestión)
export const obtenerProyectoEstudiante = (idEstudiante) =>
  new Promise((resolve) => {
    consulta(`api/v1.0/proyecto_vida/gestion/estudiante/${idEstudiante}/proyecto`, null, "GET", (error, estado, resp) => {
      resolve({ error, estado, resp });
    });
  });

// GET: versiones (actual + historial) de un estudiante específico
export const obtenerVersionesEstudiante = (idEstudiante) =>
  new Promise((resolve) => {
    consulta(`api/v1.0/proyecto_vida/gestion/estudiante/${idEstudiante}/versiones`, null, "GET", (error, estado, resp) => {
      resolve({ error, estado, resp });
    });
  });

// GET: foto (base64) de un estudiante específico (Microsoft Graph)
export const obtenerFotoEstudiante = (idEstudiante) =>
  new Promise((resolve) => {
    consulta(`api/v1.0/proyecto_vida/gestion/estudiante/${idEstudiante}/foto`, null, "GET", (error, estado, resp) => {
      resolve({ error, estado, resp });
    });
  });

/* -------------------------------------------------------------------------- */
/*  Gestión (Análisis de información).                                          */
/* -------------------------------------------------------------------------- */

const _qsAnalisis = ({ programa, semestre } = {}) => {
  let params = [];
  if (programa) params.push(`programa=${programa}`);
  if (semestre) params.push(`semestre=${semestre}`);
  return params.length ? `?${params.join("&")}` : "";
};

// GET: resumen general (se consulta al dar "Generar Análisis").
// Devuelve { totalEstudiantes, totalGeneral, porcentaje }.
export const obtenerAnalisisResumen = (filtros) =>
  new Promise((resolve) => {
    consulta(`api/v1.0/proyecto_vida/gestion/analisis${_qsAnalisis(filtros)}`, null, "GET", (error, estado, resp) => {
      resolve({ error, estado, resp });
    });
  });

// GET: análisis de una sección (se consulta al hacer clic en su pestaña).
// Devuelve { palabraFrecuente, totalPalabras, nube: [{ text, value }] }.
export const obtenerAnalisisSeccion = (seccion, filtros) =>
  new Promise((resolve) => {
    consulta(`api/v1.0/proyecto_vida/gestion/analisis/${seccion}${_qsAnalisis(filtros)}`, null, "GET", (error, estado, resp) => {
      resolve({ error, estado, resp });
    });
  });
